'use client';

import React, { useCallback, useState, useEffect } from 'react';
import Modal from '@components/modal';

import { useTuVisibilityContext } from './tu-visibility-context';
import TuModalStepperWithProvider, { TuStep } from './tu-modal-stepper';

interface Props {
  handleOnSuccess?: () => void;
}

const TuModal = ({ handleOnSuccess }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { tuVisibility, setTuVisibility } = useTuVisibilityContext();

  useEffect(() => {
    if (isModalOpen !== tuVisibility.show) {
      setIsModalOpen(tuVisibility.show);
    }
  }, [isModalOpen, tuVisibility.show]);

  const handleCloseModal = useCallback(() => {
    setTuVisibility({
      show: false,
      tuStep: null,
    });
  }, [setTuVisibility]);

  useEffect(() => {
    if (tuVisibility.tuStep === TuStep.TU_SUCCESS) {
      if (handleOnSuccess) {
        handleOnSuccess();
      }
      handleCloseModal();
    } else if (tuVisibility.tuStep === TuStep.TU_END) {
      handleCloseModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Only want to execute on step changes
  }, [tuVisibility.tuStep]);

  return (
    <Modal
      open={isModalOpen}
      onClose={handleCloseModal}
      ariaLabelledby="credit-score-activation-modal"
    >
      <TuModalStepperWithProvider />
    </Modal>
  );
};

export default TuModal;
